import React from 'react';
import './WorkTypeToggle.css';

// V71.3.1 — girişte zorunlu çalışma şekli (Ofis / Remote). Seçim oturum açılınca o günün
// kaydına yazılır; İK › Evden Çalışma bu veriyi okur.
const OPTIONS = [
  { value: 'office', label: 'Ofis', icon: '🏢' },
  { value: 'remote', label: 'Remote', icon: '🏠' },
];

export default function WorkTypeToggle({ value, onChange, disabled, invalid }) {
  return (
    <div className="form-group">
      <div className="form-label">Çalışma Şekli <span className="wt-req">*</span></div>
      <div className={`wt-toggle${invalid ? ' invalid' : ''}`} role="radiogroup" aria-label="Çalışma şekli" aria-required="true">
        {OPTIONS.map(o => (
          <button key={o.value} type="button" role="radio" aria-checked={value === o.value}
            className={`wt-opt${value === o.value ? ' active' : ''}`} disabled={disabled} onClick={() => onChange(o.value)}>
            <span className="wt-ic" aria-hidden="true">{o.icon}</span>{o.label}
          </button>
        ))}
      </div>
    </div>
  );
}
